<template>


<div>

	
<!--右侧导航-->
  <div class="mui-mbar-tabs">
	<div class="quick_link_mian" >
  <div class="quick_links_panel">
  <div id="quick_links" class="quick_links">
<el-menu default-active="1-4-1" class="el-menu-vertical-demo" :collapse="isCollapse">

  <el-menu-item index="0">
    <a href="/"><i class="right0"></i></a>
    <span slot="title"><a href="/" style="color: #fff;">科欣首页</a></span>
  </el-menu-item>

  <!-- <el-menu-item index="1">
    <a href="#"><i class="right1"></i></a>
    <span slot="title"><a href="#" style="color: #fff;">客服中心</a></span>
  </el-menu-item> -->
  
  <el-menu-item index="2">
    <a href="/user/index"><i class="right2"></i></a>
    <span slot="title"><a href="/user/index" style="color: #fff;">个人中心</a></span>
  </el-menu-item>
  
  <el-menu-item index="3">
    <a href="#"><i class="right3"></i></a>
    <span slot="title"><a href="#" style="color: #fff;">站内信</a></span>
  </el-menu-item>
  
  <el-menu-item index="4">
    <a href="#"><i class="right4"></i></a>
    <span slot="title"><a href="#" style="color: #fff;">通知公告</a></span>
  </el-menu-item>
  
  <el-menu-item index="5">
    <a href="/user/fav"><i class="right5"></i></a>
    <span slot="title"><a href="/user/fav" style="color: #fff;">我的收藏</a></span>
  </el-menu-item>
  
  <el-menu-item index="6">
    <a href="/cart/index"><i class="right6"></i></a>
    <span slot="title"><a href="/cart/index" style="color: #fff;">我的购物车</a></span>
  </el-menu-item>
  
  <el-menu-item index="7">
    <a href="/coupon/"><i class="right7"></i></a>
    <span slot="title"><a href="/coupon/" style="color: #fff;">优惠券</a></span>
  </el-menu-item>


  
</el-menu>
</div>

    <div class="quick_toggle">
  <el-menu default-active="1-4-1" class="el-menu-vertical-demo" :collapse="isCollapse">
     <el-menu-item index="8">
    <i class="right8" @click="backtop"></i>
    <span slot="title">顶部</span>
    </el-menu-item>
  </el-menu>
    </div>
  
</div>
</div>

</div>
<!--右侧导航end-->	

<chat sellerId="parseInt(1)" :miniItem="true"></chat>
</div>
</template>

<script>
import chat from "@/components/chat/index.vue";
export default {
    components: {
      chat
    },
    props: {
        list:{
            type:Array,
        },
        class_info:{
            type:Object,
            default:()=>{
                return {name:'加载中...'}
            }
        },

    },
    data() {
      return {
        isCollapse: true
      };
    },
    watch: {},
    computed: {},
    methods: {
        // 显示回到顶部按钮
       showbtn(){
          let that = this;
          let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
          that.scrollTop = scrollTop
       },
      /**
        * 回到顶部功能实现过程：
        * 1. 获取页面当前距离顶部的滚动距离（虽然IE不常用了，但还是需要考虑一下兼容性的）
        * 2. 计算出每次向上移动的距离，用负的滚动距离除以5，因为滚动的距离是一个正数，想向上移动就是做一个减法
        * 3. 用当前距离加上计算出的距离，然后赋值给当前距离，就可以达到向上移动的效果
        * 4. 最后记得在移动到顶部时，清除定时器
      */
      backtop(){
          var timer = setInterval(function(){
            let osTop = document.documentElement.scrollTop || document.body.scrollTop;
            let ispeed = Math.floor(-osTop / 5); 
            document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
            this.isTop = true;
            if(osTop === 0){
              clearInterval(timer);
            }
          },30)
      },
    },
    created() {
    },
    mounted() {
       window.addEventListener("scroll",this.showbtn,true);
    },
};
</script>
<style lang="scss" scoped>
.product_left{
    width: 234px;
    height: 614px;
    float: left;
    -webkit-transition: all .2s linear;
    transition: all .2s linear;
}
.product_left:hover{
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.4);
}
.product_right{
    width: 966px;
    float: left;
    ul li{
        width: 220px;
        height: 300px;
        margin-bottom: 14px;
        margin-left: 20px;
        box-sizing: border-box;
        float: left;
        .product_act_in{
            width: 220px;
            height: 300px;
            background: #fff;
            box-sizing: border-box;
            -webkit-transition: all .2s linear;
            transition: all .2s linear;
        }
        dl dt{
            width: 140px;
            height: 140px;
            margin:0 auto;
            padding-top: 20px;
        }
        dl dt img{
            width: 180px;
            height: 180px;
        }
        dl dd{
            width: 190px;
            overflow: hidden;
            text-align: center;
            margin:0 auto;
        }
        dl dd.product_title{
            font-size: 14px;
            margin-top: 25px;
            height: 30px;
            line-height: 30px;
        }
        dl dd.product_subtitle{
            margin-top: 0px;
            font-size: 12px;
            color:#b0b0b0;
            line-height: 14px;
        }
        dl dd.product_price{
            margin-top: 10px;
            font-size: 16px;
            color:#409EFF;
            line-height: 34px;
            span{
                font-size: 14px;
                color:#b0b0b0;
                margin-left: 8px;
                text-decoration: line-through;
            }
        }
    }
    
    ul li:hover .product_act_in{
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        margin-top:-3px;
    }
    
}
.seckill_title{
    font-size: 22px;
    margin-bottom: 20px;
    span{
        float:right;
        font-size: 14px;
        padding-right: 15px;
    }
    a:hover{
        color:#409EFF;
    }
}



.lift-channel {margin-top: 30px;}
.lift-channel ul{ width:calc(100% + 10px); width:1210px\0;}
.lift-channel li{ float:left; width:210px; margin:0 10px 10px 0; border:1px solid #D2D2D2; padding:10px;}
.lift-channel li:hover{ border-color:#409EFF;}
.lift-channel li .p-img{ width:210px; height:210px;}
.lift-channel li .p-name{ font-size:14px; overflow:hidden; white-space: nowrap;text-overflow: ellipsis; margin-top:8px;}
.lift-channel li .p-price { line-height:36px;}
.lift-channel li .p-price .shop-price{ float:left; font-size:16px; color:#409EFF;}
.lift-channel li .p-price .original-price{ float:left; margin-left:5px; color:#555;}

.lift{ position: fixed;-moz-transform: translate(0,-50%) scale(1,1); -webkit-transform: translate(0,-50%) scale(1,1); -o-transform: translate(0,-50%) scale(1,1); transform: translate(0,-50%) scale(1,1); opacity: 1; filter:alpha(opacity=100); z-index: 100; -moz-transition: all .2s; -o-transition: all .2s; -webkit-transition: all .2s; transition: all .2s;}
.lift-hide{ transform: translate(0,-50%) scale(0,0); -webkit-transform: translate(0,-50%) scale(0,0); -moz-transform: translate(0,-50%) scale(0,0); -o-transform: translate(0,-50%) scale(0,0); opacity: 0; filter:alpha(opacity=0);}







.el-menu {
    border-right: none !important;
    list-style: none;
    position: relative;
    margin: 0;
    padding-left: 0;
    background: none !important;

}
.el-menu-vertical-demo a, .el-menu-vertical-demo  a:hover{
  color: #fff !important;
}
.el-menu:hover,.el-menu-item:hover{
  background: none !important;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}


</style>